import { Component } from 'react'
import * as PropTypes from 'prop-types'

export default class AppAuthed extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
  }

  componentWillMount() {
    this.onMount(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.onMount(nextProps)
  }

  onMount = props => {
    const {
      isLoggedIn,
      allConfirmed,
      goLogin,
      goSettings,
      location: { pathname, hash },
    } = props

    if (!isLoggedIn) {
      // store original pathname to redirect to it after auth
      window._originalPathname = pathname
      window._originalHash = hash
      goLogin()
      return
    }

    if (!allConfirmed && pathname !== '/dashboard/settings') {
      goSettings()
    }
  }

  render() {
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/AppAuthed/AppAuthed.js